import React, { useEffect, useState, useContext, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

import Tooltip from "@mui/material/Tooltip";
import Pagination from "@mui/material/Pagination";

import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";
import SuiAvatar from "components/SuiAvatar";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Switch from "@mui/material/Switch";

import { AccountContext } from "context/account";
import CategoryContext from "context/category-context";

import toast from "react-hot-toast";
import qs from "query-string";

import moment from "moment";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "antd";
import UTreeSelect from "components/UpStyled/UTreeSelect";

import { filterParser, sortParser } from "utils/helper";
import { stylesSortOptions, seasonOptions } from "utils/data";
import { handleUploadFiles, getStyleImages, canResizeImageUrl } from "utils/imageHelper";

import TechPackCard from "components/UpStyled/TechPackCard";
import FullCreateStyleModal from "pages/de/project/create-project/components/FullCreateStyleModal";

import EmptyStyleCard from "pages/de/styles/components/EmptyStyleCard";

import Error404 from "pages/error/404";

const TechpackList = ({ create = false }) => {
  const [data, setData] = useState({ hits: [], nbHits: 0, estimatedTotalHits: 0 });

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [searchStr, setSearchStr] = useState("");
  const [filterObj, setFilterObj] = useState({});
  const [createStyleVisible, setCreateStyleVisible] = useState(false);
  const [collectionOptions, setCollectionOptions] = useState([]);

  const navigate = useNavigate();
  let location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  const action = urlObj?.query?.a;

  const user = useContext(AccountContext);

  const {
    tree,
    actions: { findNodeByID, findParents },
  } = useContext(CategoryContext);

  const {
    register,
    handleSubmit,
    trigger,
    setValue,
    watch,
    getValues,
    reset,
    formState: { errors },
    control,
  } = useForm();

  useEffect(() => {
    reset({ sort_by: stylesSortOptions[0] });
    retrieveCollections();
  }, []);

  useEffect(() => {
    if (create) {
      handleAddTechPack();
    }
  }, [create]);

  useEffect(() => {
    if (user.id) {
      const offset = pageSize * (page - 1);
      const limit = pageSize;
      let filter = {};
      retrieveStyles(offset, limit, "", filter);
    }
  }, [user.id]);

  useEffect(() => {
    if (action == "create") {
      setCreateStyleVisible(true);
    }
  }, []);

  const handleAddTechPack = async () => {
    try {
      const style_number = "TEMP_" + moment().format("YYYYMMHHmmss");
      let payload = {
        title: "Untitled",
        status: "design",
        description: "",
        options: [],
        collection_id: null,
        style: {
          style_number: style_number,
          year: moment().format("YYYY"),
        },
      };
      //create style(tech pack)
      const newCreatedProduct = await api.products.create(payload);
      const product_id = newCreatedProduct?.data?.product?.id;

      toast.success(`Your Tech Pack has been successfully created!`);
      navigate(`/workspace/styles-master?id=${product_id}&techpackboard=Sketches`, {
        replace: true,
      });
    } catch (err) {
      toast.error(`Your Tech Pack could not be created!`);
      console.log(err);
    }
  };

  const retrieveStyles = async (offset = 0, limit = pageSize, q = "", filter = {}) => {
    const payload = { offset, limit };
    if (q) {
      payload["q"] = q;
    }
    let myFilter = {};

    if (Object.keys(filter).length > 0) {
      myFilter = { ...myFilter, ...filter };
    }

    //get sorting options from form values
    const sortOpt = getValues("sort_by");
    let sortStr = "";

    if (sortOpt && sortOpt.value) {
      sortStr = sortParser(sortOpt.value);
    }

    myFilter = {
      ...myFilter,
    };

    const newFilterStr = filterParser(myFilter);
    if (newFilterStr) {
      payload["filter"] = newFilterStr;
      setFilterObj(myFilter);
    }
    if (sortStr) {
      payload["sort"] = [sortStr];
    }
    try {
      //const { data } = await api.project.list({ owner_id: user.id });

      const { data } = await api.products.searchStyles(payload);

      setData(data ? data : { hits: [], nbHits: 0 });
    } catch (err) {
      console.log(err);
    }
  };

  const retrieveCollections = async () => {
    try {
      const { data } = await api.collections.list({ order: "-updated_at" });

      const collections = data["collections"] ? data["collections"] : [];
      const options = collections.map((x) => ({ label: x.title, value: x.id }));
      setCollectionOptions(options);
    } catch (err) {
      toast.error(`Retrieve collection list failed`);
      console.log(err);
    }
  };

  const handleApply = () => {
    const data = getValues();
    const offset = pageSize * (page - 1);
    const limit = pageSize;
    setSearchStr(data["keywords"]);
    let myFilter = {};

    //collection filter
    if (data["collection"] && data["collection"].value) {
      myFilter["collection_id"] = data["collection"].value;
    }
    //category filter
    if (data["category"]) {
      myFilter["categories"] = data["category"];
    }
    //season filter
    if (data["season"] && data["season"]?.value) {
      myFilter["style_season"] = data["season"].value;
    }
    //year filter
    if (data["year"]) {
      let formatYearValue = moment(data["year"]).format("YYYY");
      myFilter["style_year"] = formatYearValue;
    }

    retrieveStyles(offset, limit, data["keywords"], myFilter);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const offset = pageSize * (newPage - 1);
    const limit = pageSize;
    retrieveStyles(offset, limit, searchStr, filterObj);
  };

  const handleChangeRowsPerPage = (option) => {
    const newPageSize = parseInt(option.value, 10);
    setPageSize(newPageSize);
    setPage(1);
    const offset = 0;
    const limit = newPageSize;
    retrieveStyles(offset, limit, searchStr, filterObj);
  };

  const totalNumber = data.nbHits ? data.nbHits : data.estimatedTotalHits;
  const pageCount = parseInt(Math.ceil(totalNumber / pageSize), 10);
  const pageOptions = [];
  for (let i = 0; i < pageCount; i++) {
    pageOptions.push(i);
  }
  const entriesStart = pageSize * (page - 1) + 1;
  const entriesEnd = pageSize * page > totalNumber ? totalNumber : pageSize * page;

  const handleClearFilter = () => {
    reset({
      season: null,
      year: null,
      collection: null,
      category: null,
      sort_by: stylesSortOptions[0],
      q: "",
    });
    const offset = pageSize * (page - 1);
    const limit = pageSize;
    handleApply();
  };

  const handleAfterOk = (newStyle) => {
    let id = newStyle?.data?.product?.id;
    if (id) {
      navigate(`/workspace/styles-master?id=${id}`);
    }
  };

  return (
    <SuiBox my={1}>
      <SuiBox display="flex" justifyContent="space-between" pb={1}>
        <SuiButton
          variant="gradient"
          color={"dark"}
          onClick={() => {
            setCreateStyleVisible(true);
          }}
        >
          New Tech Pack
        </SuiButton>
      </SuiBox>

      <Card sx={{ p: 3 }}>
        <SuiBox component="form" pb={3} onSubmit={handleSubmit(handleApply)}>
          <SuiBox
            display="flex"
            alignItems="flex-start"
            justifyContent="space-between"
            sx={{ width: "100%" }}
          >
            <SuiBox display="flex" alignItems="center" sx={{ gap: 0.5, flexWrap: "wrap" }}>
              <SuiTypography variant="button" color="dark" fontWeight="regular">
                Filter by:
              </SuiTypography>
              <div style={{ width: 100 }}>
                <Controller
                  name="year"
                  control={control}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      picker="year"
                      placeholder="Year"
                      style={{
                        height: 40,
                        width: "100%",
                        borderRadius: "8px",
                        border: "1px solid #d2d6da",
                      }}
                      popupStyle={{
                        maxHeight: 400,

                        overflow: "auto",
                        zIndex: 9999,
                      }}
                    />
                  )}
                />
              </div>
              <div style={{ width: 130 }}>
                <Controller
                  name="season"
                  control={control}
                  render={({ field }) => (
                    <SuiSelect
                      {...field}
                      options={seasonOptions}
                      placeholder="Season"
                      backspaceRemovesValue
                    />
                  )}
                />
              </div>
              <div style={{ width: 160 }}>
                <Controller
                  name="collection"
                  control={control}
                  render={({ field }) => (
                    <SuiSelect
                      {...field}
                      options={collectionOptions}
                      placeholder="Collection"
                      backspaceRemovesValue
                    />
                  )}
                />
              </div>
              <div style={{ minWidth: 220 }}>
                <Controller
                  control={control}
                  name="category"
                  render={({ field: { onChange, onBlur, value, name, ref } }) => (
                    <UTreeSelect
                      tree={tree}
                      fieldNames={{ label: "label", value: "id", children: "children" }}
                      onChange={(e) => {
                        onChange(e);
                      }}
                      allowClear={true}
                      value={value}
                      placeholder="Category"
                    />
                  )}
                />
              </div>
              <div style={{ width: 145 }}>
                <Controller
                  name="sort_by"
                  control={control}
                  render={({ field }) => (
                    <SuiSelect
                      {...field}
                      options={stylesSortOptions}
                      placeholder="Sort By"
                      backspaceRemovesValue
                    />
                  )}
                />
              </div>
              <SuiBox>
                <SuiInput placeholder="Keywords" type="text" {...register("keywords")} />
              </SuiBox>
              <div>
                <SuiButton variant="gradient" color="dark" type="submit">
                  Apply
                </SuiButton>
              </div>
              <SuiButton variant="text" color="dark" onClick={handleClearFilter}>
                Clear
              </SuiButton>
            </SuiBox>
          </SuiBox>
        </SuiBox>

        <SuiBox display="flex" justifyContent="flex-start" sx={{ flexWrap: "wrap" }}>
          {data.hits.map((u, index) => {
            return (
              <TechPackCard
                product={u}
                size="md"
                detailUrl={`/workspace/styles-master?id=${u.id}&stage=tech-pack`}
              />
            );
          })}
        </SuiBox>
        <SuiBox
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          p={3}
        >
          <div className="flex items-center">
            <SuiBox mb={{ xs: 3, sm: 0 }}>
              <SuiTypography variant="button" color="secondary" fontWeight="regular">
                Showing {entriesStart} to {entriesEnd} of {totalNumber} entries
              </SuiTypography>
            </SuiBox>

            <SuiBox display="flex" alignItems="center" gap={1}>
              <SuiSelect
                defaultValue={{ value: pageSize, label: pageSize }}
                options={[10, 20, 50].map((entry) => ({ value: entry, label: entry }))}
                onChange={handleChangeRowsPerPage}
                size="small"
              />

              <SuiTypography variant="caption" color="secondary">
                entries per page
              </SuiTypography>
            </SuiBox>
          </div>
          <Pagination
            variant={"outlined"}
            color={"info"}
            count={pageOptions.length}
            defaultPage={page}
            onChange={handleChangePage}
          />
        </SuiBox>
      </Card>
      {createStyleVisible ? (
        <FullCreateStyleModal
          handleClose={() => setCreateStyleVisible(false)}
          //handleOk={(data) => handleCreateStyle(data)}
          visible={createStyleVisible}
          isEdit={false}
          categoryTree={tree}
          //ref={addStyleRef}
          handleRefresh={() => {
            const offset = pageSize * (page - 1);
            const limit = pageSize;
            let filter = {};
            retrieveStyles(offset, limit, "", filter);
          }}
          refreshDelay={2000}
          handleAfterOk={handleAfterOk}
        />
      ) : null}
    </SuiBox>
  );
};

export default TechpackList;
